/** sqlite-worker - SQLite-Anfragen abarbeiten / puffern
 *  - vormals benannt "DBSQlite"
 * 
 *  @param ENV_SETTINGS_JS.NS  - Namespacing, z.B. "kh-menue"
 * 
*/

import { CapacitorSQLite, SQLiteConnection, SQLiteDBConnection } from '@capacitor-community/sqlite';

const sqlite = new SQLiteConnection(CapacitorSQLite);

let dbBuffer = [] ;
let dbBufferError = [] ;
let dbBufferBusy = false;
let dbBufferIn = 0;
let dbBufferOut = 0;
let sqliteFailure = false;

export function dbQuery(qry,target){
  if( sqliteFailure ) {
    dbBufferBusy = false ;
    sqliteFailure = false ;
  }
  dbBufferIn++
  dbBuffer.push([qry,target])
  dbBufferWorker()
}

export async function dbBufferWorker(){
  if(dbBufferBusy===false){
    if(dbBuffer.length>0){
      dbBufferBusy=true
      try {
        const ret = await sqlite.checkConnectionsConsistency();
        const isConn = (await sqlite.isConnection( ENV_SETTINGS_JS.NS ,false)).result;
        var db;
       if (ret.result && isConn) {
        db = await sqlite.retrieveConnection( ENV_SETTINGS_JS.NS ,false);
        } else {
        db = await sqlite.createConnection( ENV_SETTINGS_JS.NS , false, 'no-encryption', 1 , false );
        }
        //const db: SQLiteDBConnection = await sqlite.createConnection( ENV_SETTINGS_JS.NS , false, 'no-encryption', 1, false);
      
        const isDb = (await db.isExists()).result;
        if ( ! isDb ) {
          console.error('DBInit: DB nicht connected');
        }
        await db.open();
        const isDbOpen = (await db.isDBOpen()).result;
        if ( ! isDbOpen ) {
          console.error('DBInit: DB nicht open');
        }
        while(dbBuffer.length>0){
          let myChanges = await db.query( dbBuffer[0][0] );
          if(typeof dbBuffer[0][1] === 'function'){
            dbBuffer[0][1](myChanges)
          }
          dbBuffer.shift()
          dbBufferOut++
        }
        await db.close();
        await sqlite.closeConnection( ENV_SETTINGS_JS.NS ,false);
      } 
      catch (err) {
        sqliteFailure = true ;
        dbBufferError
          .push(
            [
              new Date().toLocaleString() ,
              err ,
              dbBuffer.shift()
            ]
          )
        console.error( 'dbBufferWorker Try/Catch-Fehler: ', err );
        console.error( 'Fehler dbBufferWorker: ', dbBufferError[ dbBufferError.length - 1 ] );
        console.info( 'Fehlerliste dbBufferWorker: ', dbBufferError );
      }
      finally {
        if( ! sqliteFailure ) {
          dbBufferBusy=false
          dbBufferWorker()
        }
      }
    }   
  }
}

export function exportDbBufferIn( action ){
  if( action === 'reset' ) {
    dbBufferIn = 0 ;
  }
  return dbBufferIn
}

export function exportDbBufferOut( action ){
  if( action === 'reset' ) {
    dbBufferOut = 0 ;
  }
  return dbBufferOut
}

export function exportDBBufferEmpty() {
  if(dbBuffer.length>0){
    return false
  }
  return true
  
}